/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span[_ngcontent-%COMP%]{color:#025072;color:var(--customPrimary)}a[_ngcontent-%COMP%]{font-size:1.3rem;font-weight:700;cursor:pointer}a[_ngcontent-%COMP%]:hover{text-decoration:underline!important}a[_ngcontent-%COMP%]:hover   .fa-home[_ngcontent-%COMP%]:before{text-decoration:underline}"];
export { styles as styles };
